export default class RowVariant {
  get(row) {
    let color = 'error';
    if (row.noVariant) {
      color = ''
    } else if (row.ok) {
      color = 'success'
    }
    return color + ' noHover'
  }
}
